module.exports = __webpack_public_path__ + "img/yh-logo.ff159c45.png";